import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const searchByType = (userId: string, cptTypes: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CPT_CODES_BY_TYPE_REQUEST });

  return api.claim.cptCodes.searchByType(userId, cptTypes)
    .then((res: any) => {

      dispatch({
        type: types.GET_CPT_CODES_BY_TYPE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CPT_CODES_BY_TYPE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const get = (searchCriteria: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CPT_CODES_REQUEST });

  return api.claim.cptCodes.get(searchCriteria)
    .then((res: any) => {

      dispatch({
        type: types.GET_CPT_CODES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CPT_CODES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
  